/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 09:51:35
 * @LastEditTime: 2020-11-20 10:55:19
 * @FilePath: \ensurance-front\src\views\home\home.js
 */
import SidebarCommon from '@/components/sidebar-common'
import HeaderCommon from '@/components/header-common'
import { mapState } from 'vuex'
export default {
  components: {
    SidebarCommon,
    HeaderCommon
  },
  computed: {
    ...mapState({
      catch_components: state => state.tabs.catch_components, // keepalive缓存
      // 从 state 中的到的计算属性
      activePath: state => state.tabs.activePath, // 已选中菜单
      tabList: state => state.tabs.tabList // tags菜单列表
    })
  },
  data() {
    return {
      msg: '123'
    }
  },
  methods: {
    // 关闭tab标签
    handleClose(tab, index) {
      // 历史选中菜单
      let oldActivePath = this.$store.state.tabs.activePath
      // 历史已选中菜单列表
      let oldTabList = this.$store.state.tabs.tabList
      // 计算标签个数
      let length = oldTabList.length - 1
      // 删除tabList中的该对象
      for (let i = 0; i < oldTabList.length; i++) {
        let item = oldTabList[i]
        if (item.name === tab.name) {
          oldTabList.splice(i, 1)
        }
      }
      // 删除keepAlive缓存
      this.$store.commit('removeKeepAliveCache', tab.name)
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tab.name !== oldActivePath) {
        return
      }
      // 如果length为1，必然只剩下首页标签，此时关闭后，更新到首页
      if (length === 1) {
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: 'home', tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ path: oldTabList[index - 1].path })
        // 不再向下执行
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        // 同时更新路径
        oldActivePath = oldTabList[index - 1].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ path: oldTabList[index - 1].path })
      } else {
        // 同时更新路径
        oldActivePath = oldTabList[index].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向右跳转
        this.$router.push({ path: oldTabList[index].path })
      }
    },
    // 点击标签跳转路由
    changeMenu(item) {
      // 历史选中菜单
      let oldActivePath = this.$store.state.activePath
      // 首先判断点击的是否是自己，如果是自己则return

      console.info('oldActivePath', oldActivePath)
      console.info('item.name', item.name)
      if (oldActivePath === item.name) {
        return
      }
      // 不是自己，存储菜单
      this.$store.commit('changeMenu', item.name)
      // 页面跳转
      this.$router.push({ path: item.path })
    },
    // 关闭菜单
    closeTab(state, val) {
      // 重新赋值
      state.activePath = val.activePath
      state.tabList = val.tabList
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/home.js